import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { updateUser } from '../actions/userActions';
import { resetModal } from '../actions/modalsActions';
import i18n from '../utils/i18n';
import Modal from './Modal';

import './styles/LearnAboutPremiumModal.scss';

class LearAboutPremiumModal extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.registerAsInterestedInPremium = this.registerAsInterestedInPremium.bind(
      this
    );
  }

  registerAsInterestedInPremium() {
    this.props.updateUser({
      interested_in_premium: true
    });
    this.close();
  }

  close() {
    this.props.resetModal();
  }

  render() {
    return (
      <Modal
        isOpen={ true }
        onRequestClose={ this.close }
        closeButtonText={ i18n.t('modals.welcome.NOT_JOIN_DEUCE_PREMIUM') }
        actionButtonText={ i18n.t('modals.welcome.JOIN_DEUCE_PREMIUM') }
        actionFunction={ this.registerAsInterestedInPremium }
      >
        <div className="modal-container">
          <h1 className="modal-header">
            {i18n.t('modals.welcome.BECOME_DEUCE_PREMIUM')}
          </h1>
          <p>{i18n.t('modals.welcome.DEUCE_PREMIUM_TOP_DESCRIPTION')}</p>

          <div className="premium-cost">
            <span className="premium-price">£10</span>
            <span className="premium-price-term">/month</span>
          </div>
          <p>{i18n.t('modals.welcome.DEUCE_PREMIUM_BOTTOM_DESCRIPTION')}</p>
        </div>
      </Modal>
    );
  }
}

LearAboutPremiumModal.propTypes = {
  resetModal: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  updateUser: params => dispatch(updateUser(params)),
  resetModal: () => dispatch(resetModal())
});

export default connect(null, mapDispatchToProps)(LearAboutPremiumModal);



// WEBPACK FOOTER //
// ./src/modals/LearAboutPremiumModal.js